import { Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import useAddToCompanyDialog from '../../hooks/useAddToCompanyDialog';
import useUserSWR from '../../hooks/user/useUserSWR';
import PrimaryBtn from '../shared/Buttons/PrimaryButton';

export const MyCompany = () => {
    const { user, isLoading, isError } = useUserSWR();
    const { t } = useTranslation('profile');

    const addToCompanyDialog = useAddToCompanyDialog();

    const handleAddToCompanyClick = () => {
        addToCompanyDialog.showDialog(
            true,
            user.bc_company_number.toString(),
            user.company,
            false
        );
    };

    return (
        <Box>
            <Box sx={{ paddingBottom: '10px' }}>
                <Typography variant="h2">
                    {t('PROFILE.COMPANY.TITLE')}
                </Typography>
            </Box>
            {!isLoading && !isError && (
                <>
                    <Box>{t('PROFILE.COMPANY.ADD_PARTNER.CONTENT')}</Box>
                    <Box sx={{ paddingTop: '10px' }}>
                        <PrimaryBtn onClick={handleAddToCompanyClick}>
                            {t('PROFILE.COMPANY.ADD_PARTNER.BUTTON')}
                        </PrimaryBtn>
                    </Box>
                </>
            )}
        </Box>
    );
};
